import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const FinalCTA = () => (
  <section className="relative overflow-hidden bg-navy py-24 md:py-36" data-testid="final-cta-section">
    <div className="pointer-events-none absolute left-1/2 top-0 h-[480px] w-[480px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/10 blur-3xl" aria-hidden="true" />
    <div className="container-x relative text-center">
      <Reveal>
        <p className="eyebrow" data-testid="final-cta-eyebrow">Manage. Protect. Grow.</p>
        <h2 className="mx-auto mt-5 max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tighter text-white sm:text-5xl lg:text-6xl">
          See what ANFORD sees.
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-white/75 lg:text-lg">
          Discover how ANFORD brings your properties, operations, financial performance and intelligence together.
        </p>
        <div className="mt-10 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
          <Link to="/demo" data-testid="final-cta-book-demo-button" className="btn-gold">
            Book Your Private Demo <ArrowRight className="h-4 w-4" />
          </Link>
          <a href="mailto:info@anfordpim.com" data-testid="final-cta-contact-link" className="btn-outline-light">
            Contact ANFORD
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
